import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { bind } from 'bind-event-listener';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { calculateToolbarPositionAboveSelection, calculateToolbarPositionTrackHead } from '@atlaskit/editor-common/utils';
import { NodeSelection } from '@atlaskit/editor-prosemirror/state';
import { selectionToolbarPluginKey } from './plugin-key';
export var selectionToolbarPlugin = function selectionToolbarPlugin(options) {
  var __selectionToolbarHandlers = [];
  return {
    name: 'selectionToolbar',
    pmPlugins: function pmPlugins(selectionToolbarHandlers) {
      if (selectionToolbarHandlers) {
        __selectionToolbarHandlers.push.apply(__selectionToolbarHandlers, _toConsumableArray(selectionToolbarHandlers));
      }
      return [{
        name: 'selection-tracker',
        plugin: function plugin() {
          return new SafePlugin({
            key: selectionToolbarPluginKey,
            state: {
              init: function init() {
                return {
                  selectionStable: false
                };
              },
              apply: function apply(tr, pluginState) {
                var meta = tr.getMeta(selectionToolbarPluginKey);
                if (meta) {
                  return _objectSpread(_objectSpread({}, pluginState), meta);
                }
                return pluginState;
              }
            },
            view: function view(_view) {
              var unbind = bind(_view.root, {
                type: 'mouseup',
                listener: function listener() {
                  var _options$api;
                  // We only want to set selectionStable to true if the editor has focus
                  // to prevent the toolbar from showing when the editor is blurred
                  // due to a click outside the editor.

                  var editorViewModePlugin = (_options$api = options.api) === null || _options$api === void 0 || (_options$api = _options$api.editorViewMode) === null || _options$api === void 0 ? void 0 : _options$api.sharedState.currentState();
                  var isViewModeEnabled = (editorViewModePlugin === null || editorViewModePlugin === void 0 ? void 0 : editorViewModePlugin.mode) === 'view';
                  _view.dispatch(_view.state.tr.setMeta(selectionToolbarPluginKey, {
                    selectionStable: !isViewModeEnabled ? _view.hasFocus() : true
                  }));
                }
              });
              var unbindEditorViewFocus = bind(_view.dom, {
                type: 'focus',
                listener: function listener() {
                  _view.dispatch(_view.state.tr.setMeta(selectionToolbarPluginKey, {
                    selectionStable: true
                  }));
                }
              });
              return {
                destroy: function destroy() {
                  unbind();
                  unbindEditorViewFocus();
                }
              };
            },
            props: {
              handleDOMEvents: {
                mousedown: function mousedown(view) {
                  view.dispatch(view.state.tr.setMeta(selectionToolbarPluginKey, {
                    selectionStable: false
                  }));
                  return false;
                }
              }
            }
          });
        }
      }];
    },
    pluginsOptions: {
      floatingToolbar: function floatingToolbar(state, intl, providerFactory) {
        var _selectionToolbarPlug = selectionToolbarPluginKey.getState(state),
          selectionStable = _selectionToolbarPlug.selectionStable;
        if (state.selection.empty || !selectionStable || state.selection instanceof NodeSelection ||
        // $anchorCell is only available in CellSelection, this check is to
        // avoid importing CellSelection from @atlaskit/editor-tables
        '$anchorCell' in state.selection) {
          // If there is no active selection, or the selection is not stable, or the selection is a node selection,
          // do not show the toolbar.
          return;
        }
        // Resolve the selectionToolbarHandlers to a list of SelectionToolbarGroups
        // and filter out any handlers which returned undefined
        var resolved = __selectionToolbarHandlers.map(function (selectionToolbarHandler) {
          return selectionToolbarHandler(state, intl, providerFactory);
        }).filter(function (resolved) {
          return resolved !== undefined;
        });
        // Sort the groups by rank
        // This is intended to allow different plugins to control the order of the groups
        // they add to the selection toolbar.
        // ie. if you want to have your plugin's group appear first, set rank to -10 if there is currently another
        // plugin you expect to be run at the same time as with an rank of -9
        resolved.sort(function (_ref, _ref2) {
          var _ref$rank = _ref.rank,
            rankA = _ref$rank === void 0 ? 0 : _ref$rank;
          var _ref2$rank = _ref2.rank,
            rankB = _ref2$rank === void 0 ? 0 : _ref2$rank;
          if (rankA < rankB) {
            return 1;
          }
          return -1;
        });
        var items = [];

        // This flattens the groups passed into the floating toolbar into a single list of items
        for (var i = 0; i < resolved.length; i++) {
          // add a seperator icon after each group except the last
          items.push.apply(items, _toConsumableArray(resolved[i].items));
          if (i !== resolved.length - 1) {
            items.push({
              type: 'separator'
            });
          }
        }
        var calcToolbarPosition = options.config.preferenceToolbarAboveSelection ? calculateToolbarPositionAboveSelection : calculateToolbarPositionTrackHead;
        var toolbarTitle = 'Selection toolbar';
        var onPositionCalculated = calcToolbarPosition(toolbarTitle);
        var nodeType = getSelectionNodeTypes(state);
        return {
          title: 'Selection toolbar',
          nodeType: nodeType,
          items: items,
          onPositionCalculated: onPositionCalculated
        };
      }
    }
  };
};
function getSelectionNodeTypes(state) {
  var selectionNodeTypes = [];
  state.doc.nodesBetween(state.selection.from, state.selection.to, function (node, _pos, parent) {
    if (selectionNodeTypes.indexOf(node.type) !== 0) {
      selectionNodeTypes.push(node.type);
    }
  });
  return selectionNodeTypes;
}